module.exports = __webpack_public_path__ + "static/img/yingyezhizhao.ba3dcee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yingyezhizhao.jpg
// module id = Rd+X
// module chunks = 1